import React from "react";
import "./About.css";
import felicia from "../images/felicia wijaya.jpg";
import oivicko from "../images/vicko.jpeg";
import christine from "../images/christine dewi.png";

const About = () => {
  return (
    <div className="about-container">
      <div className="about-hero">
        <h1 className="about-title">About Us</h1>
        <p className="about-subtitle">
          We are a team passionate about using technology to create positive environmental impact. Our Waste Detection project utilizes advanced YOLOv11 deep learning models to automatically identify and classify waste from images and videos.
        </p>
      </div>

      <div className="about-content">
        <div className="project-section">
          <h2>Discover Our Project</h2>
          <p>
           Our Waste Detection application uses advanced YOLOv11 deep learning models to recognize and classify waste in images and videos automatically. By combining AI and environmental awareness, we aim to make waste management smarter, easier, and more sustainable for everyone.
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">🖼️</span>
              <h3>Image Detection</h3>
              <p>Upload images to detect waste objects with high accuracy</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🎬</span>
              <h3>Video Detection</h3>
              <p>Process videos frame-by-frame for real-time detection</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">📊</span>
              <h3>Region Counting</h3>
              <p>Count objects in specific areas with draggable regions</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">⚡</span>
              <h3>Multiple Models</h3>
              <p>Choose from YOLOv11n, YOLOv11s, or YOLOv11m models</p>
            </div>
          </div>
        </div>

        <div className="team-section">
          <h2>Meet Our Team</h2>
          <p className="team-intro">
            Behind this project is a small team passionate about technology, design, and environmental sustainability. We believe that meaningful impact comes from collaboration, curiosity, and a shared commitment to building solutions that truly matter.
          </p>

          <div className="team-grid">
            <div className="team-card">
              <div className="team-image-container">
                <img
                  src={christine}
                  alt="Christine Dewi"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="team-name">Christine Dewi Ph.D</h3>
                <p className="team-nim-text">Lecturer</p>
              </div>
            </div>

            <div className="team-card">
              <div className="team-image-container">
                <img
                  src={oivicko}
                  alt="Oivicko Ekagani Irwanto"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="team-name">Oivicko Ekagani Irwanto</h3>
                <p className="team-nim-text">NIM: 672023006</p>
              </div>
            </div>

            <div className="team-card">
              <div className="team-image-container">
                <img src={felicia} alt="Felicia Wijaya" className="team-img" />
              </div>
              <div className="team-info">
                <h3 className="team-name">Felicia Wijaya</h3>
                <p className="team-nim-text">NIM: 672023009</p>
              </div>
            </div>
          </div>
        </div>

        <div className="tech-section">
          <h2>Tech Stacks</h2>
            <p className="team-intro">
            This project is built using a combination of modern technologies and AI frameworks to ensure accuracy, performance, and a smooth user experience. Each tool and technology was carefully chosen to support reliable waste detection and scalable development.
          </p>
          <div className="tech-grid">
            <div className="tech-item">
              <span className="tech-icon">🐍</span>
              <span className="tech-name">Python & Flask</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">⚛️</span>
              <span className="tech-name">React.js</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🤖</span>
              <span className="tech-name">YOLOv11</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">📦</span>
              <span className="tech-name">Ultralytics</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🎨</span>
              <span className="tech-name">CSS</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">📡</span>
              <span className="tech-name">REST API</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <div className="university-info">
            <h3>Universitas Kristen Satya Wacana</h3>
            <p>Faculty of Information Technology</p>
            <p>Informatics Engineering</p>
            <p className="year">© 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
